import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import { FaFilter } from 'react-icons/fa';
import Table from 'react-bootstrap/Table';
import { CSVLink } from 'react-csv';

import ApiUiController from '../../controller/ApiUiController';
import ReportAPI from '../../api/ReportAPI';
import FilterDate from '../filter/FilterDate';
import Const from '../../util/Constants';
import FilterPannel from '../filter/FilterPannel';
import FilterComplexPannel from '../filter/FilterComplexPannel';
import Util from '../../util/Util';
import withRouter from '../../util/WithRouter';
import ReportController from '../../controller/ReportController';
import Button from 'react-bootstrap/Button';

class ReportSelectToMonth extends React.Component {

  constructor(props) {
    super(props);
    this.models = reactLocalStorage.getObject(Const.Model);
    this.id = parseInt(props.match.params.reportId);

    this.export = [];

    const user = reactLocalStorage.getObject(Const.LoggedInUser);
    this.children = [user.user_id, ...user.child];

    this.report = props.report;
    this.headers = [];
    this.rows = [];
    this.data = [];
    this.state = { isFilterOpen: true, inApiCall: false };

    this.IsNotComplex = !this.report.sub_model;

    if (this.IsNotComplex) {
      this.x = this.report.x;
      this.y = this.report.y;
      this.z = this.report.z;

      this.modelX = this.models[this.report.model];
      this.modelY = this.models[this.report.model];

      this.RestrictX = Util.isAllow(this.modelX.permission, Const.PermRestricAcc);
      this.RestrictY = Util.isAllow(this.modelY.permission, Const.PermRestricAcc);
    } else {
      const x = this.report.x.split('.')[0];
      this.x = this.report.x.split('.')[1];
      const y = this.report.y.split('.')[0];
      this.y = this.report.y.split('.')[1];

      if (this.report.model.includes(` ${x}`)) {
        this.modelX = this.models[this.report.model.split(' ')[0]];
      } else if (this.report.model.includes(` ${y}`)) {
        this.modelY = this.models[this.report.model.split(' ')[0]];
      }

      if (this.report.sub_model.includes(` ${x}`)) {
        this.modelX = this.models[this.report.sub_model.split(' ')[0]];
      } else if (this.report.sub_model.includes(` ${y}`)) {
        this.modelY = this.models[this.report.sub_model.split(' ')[0]];
      }

      this.RestrictX = Util.isAllow(this.modelX.permission, Const.PermRestricAcc);
      this.RestrictY = Util.isAllow(this.modelY.permission, Const.PermRestricAcc);
    }

    const filters = [];
    if (this.report.filter) {
      const filter = JSON.parse(this.report.filter);
      for (let i = 0; i < filter.length; i++) {
        filters.push({ ...filter[i] });
        filters[i].value = FilterDate.getValue(filters[i].value, filters[i].condition);
      }
    }
    this.filters = filters;
  }

  componentDidMount() { this.loadReports(); }

  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  onData = res => {
    this.data = res;
    this.setState({ ...this.state, inApiCall: false });
  };

  onFilterChange = filters => {
    this.setState({ ...this.state, inApiCall: true });
    this.filters = filters;
    this.loadReports();
  };

  loadReports = () => {
    const restrict = this.filters.find(filter => filter.field === 'responsible_person');
    if (this.Restrict && !restrict) {
      this.filters.push({
        field: 'responsible_person', type: 'multiselect~user',
        condition: 'in', value: `${Const.Opt}${this.children.join(Const.Opt)}${Const.Opt}`
      });
    }
    ReportAPI.data(this.id, this.filters, this.onData, this.onFail);
  };

  calculte = () => {
    const xType = this.modelX.fields[this.x].field_type.includes(Const.MultiSelect);

    const user = reactLocalStorage.getObject(Const.LoggedInUser);
    const children = [user.user_id, ...user.child];
    let xOptions = ReportController.getOptions(this.modelX.fields[this.x], true);
    if (this.RestrictX && this.modelX.fields[this.x].field_type.includes('~user')) {
      xOptions = xOptions.filter(opt => children.find(child => parseInt(child) === parseInt(opt.value)) !== undefined);
    }
    let filter;
    if (this.IsNotComplex) {
      filter = this.filters.find(filter => filter.field === this.modelX.fields[this.x].field_key);
      if (filter) {
        xOptions = xOptions.filter(opt => filter.value.includes(`${Const.Opt}${opt.value}${Const.Opt}`));
      }
      this.xOptions = xOptions;
    } else {
      this.xOptions = xOptions;
    }

    let yOpts = ReportController.getHeaderMonth(this.filters, this.modelY.fields[this.y]);
    this.yOptions = yOpts;
    const rows = yOpts.map(option => option.label);

    let body = [];
    const mainTotal = ['Total'];
    for (let j = 0; j < xOptions.length; j++) {
      mainTotal.push(0);
    }
    mainTotal.push(0);

    const mainTotalCount = [''];
    for (let j = 0; j < xOptions.length; j++) mainTotalCount.push(0);
    mainTotalCount.push(0);

    for (let i = 0; i < yOpts.length; i++) {
      let row = [rows[i]];
      const yData = this.data.filter(data => ReportController.isIn(yOpts[i].value, data[this.y]));
      let rowTotal = 0;
      for (let j = 0; j < xOptions.length; j++) {
        const rData = xType ? yData.filter(data => data[this.x] && data[this.x].includes(`${Const.Opt}${xOptions[j].value}${Const.Opt}`))
          : yData.filter(data => data[this.x] === xOptions[j].value);
        let total = 0;
        if (this.z && this.z !== 'id') {
          rData.map(data => total += data[this.z] ? data[this.z] : 0);
        } else {
          total = rData.length;
        }
        if (this.report.model === Const.TextCall) {
          row.push(`${total} (${rData.length})`);
        } else {
          row.push(`${total}`);
        }
        rowTotal += total;
        mainTotal[j + 1] += total;
        mainTotalCount[j + 1] += rData.length;
      }
      mainTotal[mainTotal.length - 1] += rowTotal;
      if (this.report.model === Const.TextCall) {
        row.push(`${rowTotal} (${yData.length})`);
      } else {
        row.push(rowTotal);
      }
      body.push(row);
    }

    for (let j = 1; j < mainTotal.length; j++) {
      if (this.report.model === Const.TextCall) {
        mainTotal[j] = `${mainTotal[j]} (${mainTotalCount[j]})`;
      }
    }
    body.push(mainTotal);

    if (this.report.sort_neglect) {
      let index = body[0].length - 1;
      this.yOptions = this.yOptions.filter((_, i) => body[i][index]);
      body = body.filter(row => row[index]);

      if (body.length > 0) {
        index = body.length - 1;
        this.xOptions = this.xOptions.filter((_, i) => body[index][i + 1]);
        body = body.map((cols, i) => cols.filter((col, i) => i === 0 || body[index][i]));
      }
    }


    const headers = this.xOptions.map(option => option.label);
    headers.push('Total');

    this.export = [[this.modelY.fields[this.y].label_name, ...headers], ...body];
    return { headers, body };
  };

  loadView = (i, j) => {
    if (j === 0 || !this.IsNotComplex) return;
    let filters = [...this.filters];
    let yValue;
    if (i < this.yOptions.length) {
      //yValue = `${Const.Opt}${this.yOptions[i].value}${Const.Opt}`;
      yValue = this.yOptions[i].value;
    } else {
      yValue = `${this.yOptions[0].value.split(Const.Opt)[0]}${Const.Opt}`
        + `${this.yOptions[this.yOptions.length - 1].value.split(Const.Opt)[1]}`;
    }
    let type = this.modelY.fields[this.y].field_type;
    filters = filters.filter(filter => filter.field !== this.y);
    filters.push({ field: this.y, type, condition: 'in', value: yValue });

    let xValue;
    j--;
    if (j < this.xOptions.length) { xValue = `${Const.Opt}${this.xOptions[j].value}${Const.Opt}`; }
    else {
      xValue = `${Const.Opt}${this.xOptions.map(opt => opt.value).join(Const.Opt)}${Const.Opt}`;
    }
    type = this.modelX.fields[this.x].field_type;
    filters = filters.filter(filter => filter.field !== this.x);
    filters.push({ field: this.x, type, condition: 'in', value: xValue });

    const model = this.report.model !== 'sales_order' ? this.report.model : 'sales-order';
    this.props.navigate(`/${model}?filters=${JSON.stringify(filters)}`);
  };

  render() {
    const data = this.calculte();
    const headers = data.headers.map((header, i) =>
      <th key={`table_header_${i + 1}`}>{header}</th>);

    const body = data.body.map((row, i) =>
      <tr key={`body_${i}`}>{row.map((item, j) =>
        <td key={`body_${i}_${j}`} onClick={() => this.loadView(i, j)}>{item}</td>)}</tr>);

    return (
      <ApiUiController inApiCall={this.state.inApiCall}>
        <div className="container-fluid ">
          <div className="row">
            <div className="col-md-8">
              <div className="row">
                <div className="col-md-6"><h4>{this.report.name}</h4></div>
                <div className="col-md-6">
                  <CSVLink data={this.export} filename={`${this.report.name}.csv`}>
                    <Button className="buttons btn-success">Export</Button>
                  </CSVLink>
                </div>
              </div>
            </div>

            <div className="col-md-4 pt-1">
              <div className="row filterrow">
                <div className="col-md-12 lastcol">
                  <div className="m-right">
                    <div className="btn btn-lead btn-sm filter-button"
                      onClick={() => this.setState({ ...this.state, isFilterOpen: !this.state.isFilterOpen })}>
                      <FaFilter />
                      <span className="badge badge-danger badge-mini rounded-circle">
                        {this.filters.length}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row pt-3">
            <div className="container-fluid ">
              <div className="row">
                <div className={`col-md-${this.state.isFilterOpen ? 9 : 12}`}>
                  <Table striped bordered hover>
                    <thead>
                      <tr>
                        <th key="table_header_0">
                          {this.modelY.fields[this.y].label_name}
                        </th>
                        {headers}
                      </tr>
                    </thead>
                    <tbody className="listlead">{body}</tbody>
                  </Table>
                </div>
                {this.state.isFilterOpen ?
                  this.IsNotComplex
                    ? <FilterPannel filters={this.filters} fields={this.modelX.fields}
                      onFilterChange={this.onFilterChange} isFilterOpen={this.state.isFilterOpen} restrict={this.Restrict} />
                    : <FilterComplexPannel filters={this.filters} modelX={this.modelX} modelY={this.modelY}
                      onFilterChange={this.onFilterChange} isFilterOpen={this.state.isFilterOpen} restrict={this.Restrict} />
                  : null
                }
              </div>
            </div>

          </div>
        </div>
      </ApiUiController>
    );
  }
}
export default withRouter(ReportSelectToMonth);